import { graphql } from 'react-relay';

export const hometaxLogin = graphql`
  mutation hometaxLoginMutation(
    $corpType: CorpTypeEnum!
    $loginType: LoginType!
    $certificate: Certificate
    $hometaxAccount: HometaxAccount
    $simpleAuth: SimpleAuth
  ) {
    hometaxLogin(corpType: $corpType, loginType: $loginType, certificate: $certificate, hometaxAccount: $hometaxAccount, simpleAuth: $simpleAuth) {
      result
      errors {
        code
      }
      refundToken
    }
  }
`;
